import axios from 'axios';
import { AuthenticationService } from './authentication-service';

const Api = axios.create({
  baseURL: `${process.env.VUE_APP_API}/sdi`,
  withCredentials: true,
});
Api.interceptors.request.use(AuthenticationService.requestTokenInterceptor);
Api.interceptors.response.use((success) => success, AuthenticationService.errorResponseInterceptor);

// eslint-disable-next-line import/prefer-default-export
export { Api };
